import ko from "knockout";
import $ from "jquery";
import dateHelper from "flow/utils/dateHelper";
import register from "flow/knockout/register";

register.registerKnockoutBinding("time", {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        ko.bindingHandlers.value.init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
    },
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        const value = ko.utils.unwrapObservable(valueAccessor());
        if (dateHelper.isValidTimeFormat(value)) {
            $(element).val(dateHelper.toTime(value)).trigger("change");
        }
        ko.bindingHandlers.value.update(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
    }
});
